import React from 'react';
import { useNavigate } from 'react-router-dom';
import useVibeStore from '../../store/useVibeStore';

const SparkleIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09l2.846.813-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" /></svg>;

const GlobalVibeAlert = () => {
    const { pendingAction, chatId, screenshotUrl, clearPendingAction } = useVibeStore();
    const navigate = useNavigate();

    if (!pendingAction) return null;

    const handleNavigate = () => {
        // Find if this session belongs to a project node (we don't have the nodeId here, 
        // so we navigate to the generic chat route for now. In a robust app we'd store the URL path)
        if (chatId) {
            navigate(`/chat/${chatId}`);
        }
    };

    let title = 'Antigravity Waiting';
    let message = 'The agent requires your intervention.';

    if (pendingAction === 'waiting_for_proceed') {
        title = 'Antigravity Requires Proceed';
        message = 'The agent is paused and waiting for you to review the plan and click "Proceed".';
    } else if (pendingAction === 'waiting_for_run_terminal') {
        title = 'Antigravity Waiting for Run';
        message = 'The agent wants to run a Terminal command. Please review and click "Run" or "Reject".';
    } else if (pendingAction === 'waiting_for_accept_terminal') {
        title = 'Antigravity Waiting for Accept';
        message = 'The agent is waiting for you to Accept the Terminal output.';
    } else if (pendingAction === 'waiting_for_accept_changes') {
        title = 'Antigravity Waiting for Accept Changes';
        message = 'The agent has completed changes. Please review and Accept Changes.';
    }

    return (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] w-full max-w-lg px-4 animate-in slide-in-from-top-4 fade-in duration-300">
            <div className="bg-[var(--bg-secondary)] border border-[var(--accent-primary)]/50 rounded-2xl shadow-2xl overflow-hidden shadow-[var(--accent-primary)]/10 flex">

                {/* Visual Context Thumbnail */}
                {screenshotUrl && (
                    <div
                        className="w-24 bg-black bg-cover bg-center border-r border-[var(--border-subtle)] shrink-0"
                        style={{ backgroundImage: `url("${screenshotUrl}")` }}
                    />
                )}

                <div className="p-4 flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <SparkleIcon className="w-4 h-4 text-[var(--accent-primary)]" />
                        <h4 className="font-bold text-sm text-[var(--text-main)] uppercase tracking-wider">{title}</h4>
                    </div>
                    <p className="text-xs text-[var(--text-muted)] mb-3 leading-relaxed">
                        {message}
                    </p>
                    <div className="flex gap-2">
                        <button
                            onClick={handleNavigate}
                            className="bg-[var(--accent-primary)] hover:bg-[var(--accent-hover)] text-[var(--bg-main)] text-xs font-bold px-4 py-2 rounded-lg transition-colors flex-1"
                        >
                            View & Handle
                        </button>
                        <button
                            onClick={clearPendingAction}
                            className="bg-white/5 hover:bg-white/10 text-[var(--text-main)] text-xs font-bold px-4 py-2 rounded-lg transition-colors"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalVibeAlert;
